// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc7129f9","455":"6dffce26"}[chunkId] + ".chunk.js";
};